import { lazy, Suspense, useEffect } from 'react';
import { AppShell } from './components/AppShell';
import { HomePage } from './pages/HomePage';
import { useRoute } from './lib/router';

const CaseNetworkPage = lazy(() => import('./pages/CaseNetworkPage').then((module) => ({ default: module.CaseNetworkPage })));
const CasesPage = lazy(() => import('./pages/CasesPage').then((module) => ({ default: module.CasesPage })));
const KnowledgeMapPage = lazy(() => import('./pages/KnowledgeMapPage').then((module) => ({ default: module.KnowledgeMapPage })));
const LensPage = lazy(() => import('./pages/LensPage').then((module) => ({ default: module.LensPage })));
const MethodPage = lazy(() => import('./pages/MethodPage').then((module) => ({ default: module.MethodPage })));
const NotebookPage = lazy(() => import('./pages/NotebookPage').then((module) => ({ default: module.NotebookPage })));
const OpportunitiesPage = lazy(() => import('./pages/OpportunitiesPage').then((module) => ({ default: module.OpportunitiesPage })));
const ResearchPage = lazy(() => import('./pages/ResearchPage').then((module) => ({ default: module.ResearchPage })));
const TrailsPage = lazy(() => import('./pages/TrailsPage').then((module) => ({ default: module.TrailsPage })));
const ViewedPage = lazy(() => import('./pages/ViewedPage').then((module) => ({ default: module.ViewedPage })));

function PageLoading() {
  return (
    <div className="page-loading page-pad" role="status">
      <span className="eyebrow">LOADING / 正在展开</span>
      <p>正在加载这个页面…</p>
    </div>
  );
}

export default function App() {
  const route = useRoute();
  const top = route.segments[0] ?? 'home';

  useEffect(() => {
    document.documentElement.dataset.route = top;
  }, [top]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [route.path]);

  let page;
  switch (top) {
    case 'home':
      page = <HomePage />;
      break;
    case 'atlas':
      page = <CaseNetworkPage route={route} />;
      break;
    case 'cases':
      page = <CasesPage />;
      break;
    case 'opportunities':
      page = <OpportunitiesPage route={route} />;
      break;
    case 'trails':
      page = <TrailsPage />;
      break;
    case 'notebook':
      page = <NotebookPage />;
      break;
    case 'viewed':
      page = <ViewedPage />;
      break;
    case 'method':
      page = <MethodPage />;
      break;
    case 'lens':
      page = <LensPage route={route} />;
      break;
    case 'map':
      page = <KnowledgeMapPage />;
      break;
    case 'research':
      page = <ResearchPage />;
      break;
    default:
      page = (
        <div className="not-found page-pad">
          <span className="eyebrow">404 / PAGE NOT FOUND</span>
          <h1>这条路还没有被画出来。</h1>
          <p>回到因果网，或者从案例库重新开始。</p>
          <a className="button button-primary" href="#/home">
            返回随机探索
          </a>
        </div>
      );
  }

  return (
    <AppShell route={route}>
      <Suspense fallback={<PageLoading />}>{page}</Suspense>
    </AppShell>
  );
}
